import React, { useState, lazy, Suspense } from 'react';
import './App.css';
// import './Fonts/fonts.css'
import RenderFirstPageOut from './RenderFirstPageOut'
import MobileIndex from './Mobile/Pages/MobileIndex';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import RootStore from './Store/RootStore'
import { observer } from "mobx-react-lite"

// 懒加载页面组件，按路由分割代码
const WXContactUs = lazy(() => import('./WXContactUs'));
const WXCISCTestQAPage = lazy(() => import('./WXCISCTest/Pages/WXCISCTestQAPage'));
const WXCISCTestReportPage = lazy(() => import('./WXCISCTest/Pages/WXCISCTestReportPage'));
const WXCISCTestMinePage = lazy(() => import('./WXCISCTest/Pages/WXCISCTestMinePage'));
const WXCISCTestHistoryPage = lazy(() => import('./WXCISCTest/Pages/WXCISCTestHistoryPage'));
const WX4TestQAPage = lazy(() => import('./WX4Test/WX4TestQAPage'));
const WX4TestMinePage = lazy(() => import('./WX4Test/WX4TestMinePage'));
const WX4TestHistoryPage = lazy(() => import('./WX4Test/WX4TestHistoryPage'));
const WX4TestReportPage = lazy(() => import('./WX4Test/WX4TestReportPage'));

const App = observer(() => {

  let fontStyles;

  // 根据操作系统选择字体样式文件
  if (navigator.userAgent.toLowerCase().includes('micromessenger') !== -1) {
    fontStyles = require('./Fonts/fontsmobile.css');
  } else if (navigator.userAgent.indexOf('Windows') !== -1) {
    fontStyles = require('./Fonts/fonts.css');
  } else if (navigator.userAgent.indexOf('Mac') !== -1) {
    fontStyles = require('./Fonts/fontsmobile.css');
  } else if (navigator.userAgent.indexOf('Linux') !== -1) {
    fontStyles = require('./Fonts/fonts.css');
  } else if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
    fontStyles = require('./Fonts/fontsmobile.css');
  } else if (navigator.userAgent.match(/Android/g)) {
    fontStyles = require('./Fonts/fontsmobile.css');
  } else {
    fontStyles = require('./Fonts/fonts.css');
  }


  const [isMobile, setIsMobile] = useState(document.documentElement.clientWidth <= 750);
  const [isWXCISCMobile, setIsWXCISCMobile] = useState(document.documentElement.clientWidth <= 450);


  RootStore.clientWidth = document.documentElement.clientWidth;
  RootStore.clientHeight = document.documentElement.clientHeight;

  let doc = document;
  let win = window;
  let docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

    recalc = function () {
      let clientWidth = docEl.clientWidth;
      let clientHeight = docEl.clientHeight;


      if (!clientWidth) return;
      if (clientWidth > 750) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }

      if (clientWidth > 0 && clientHeight / clientWidth > 1.65) {
        setIsWXCISCMobile(true);
      } else {
        setIsWXCISCMobile(false);
      }

      ///AppWXCISCPC
      // const container = document.querySelector('.AppWXCISCPC');
      // const windowHeight = window.innerHeight;
      // container.style.height = `${windowHeight}px`;
      // container.style.width = `${windowHeight / 2.15}px`;

      // alert(docEl.style.fontSize)
    };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);

  // return (
  //   <div className="App">
  //     {!isMobile ? <RenderFirstPageOut pageState={RootStore.pageState}/> : <MobileIndex pageState={RootStore.pageState}/>}
  //   </div>
  // );


  const mainpage =
    <div className="App">
      {!isMobile ? <RenderFirstPageOut pageState={RootStore.pageState} /> : <MobileIndex pageState={RootStore.pageState} />}
    </div>
    ;

  // 懒加载 loading 占位组件
  const PageLoading = () => <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '16px', color: '#999' }}>Loading...</div>;

  const wxcontact = <div className="App"><Suspense fallback={<PageLoading />}><WXContactUs /></Suspense></div>

  // const cisctestQA = <div className="App"><WXCISCTestQAPage /></div>
  const cisctestQA = <div className={isWXCISCMobile ? "App" : "AppWXCISCPCCaintainer"}>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WXCISCTestQAPage /></Suspense></div>
  </div>


  let cisctestReport = <div className="App"><Suspense fallback={<PageLoading />}><WXCISCTestReportPage /></Suspense></div>;
  if (isWXCISCMobile) {
    cisctestReport = <div className="App"><Suspense fallback={<PageLoading />}><WXCISCTestReportPage /></Suspense></div>
  } else {
    cisctestReport = <div className="AppWXCISXReportCaintainer">
      <div className="AppWXCISCPCReport"><Suspense fallback={<PageLoading />}><WXCISCTestReportPage /></Suspense></div>
    </div>
  }
  // const cisctestReport = <div className="App"><WXCISCTestReportPage /></div>
  // const cisctestReport = <div className={isWXCISCMobile ? "App" : "AppWXCISCPCCaintainer"}>
  //   <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><WXCISCTestReportPage /></div>
  // </div>

  // const cisctestmine = <div className='App'><WXCISCTestMinePage /></div>
  const cisctestmine = <div className={isWXCISCMobile ? "App" : "AppWXCISCPCCaintainer"}>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WXCISCTestMinePage /></Suspense></div>
  </div>

  // const cisctesthistory = <div className="App"><WXCISCTestHistoryPage /></div>
  const cisctesthistory = <div className='AppWXCISCPCCaintainer'>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WXCISCTestHistoryPage /></Suspense></div>
  </div>

  // const wx4testQA = <div className="App"><WX4TestQAPage /></div>
  const wx4testQA = <div className='AppWXCISCPCCaintainer'>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WX4TestQAPage /></Suspense></div>
  </div>

  // const wx4testmine = <div className="App"><WX4TestMinePage /></div>
  const wx4testmine = <div className={isWXCISCMobile ? "App" : "AppWXCISCPCCaintainer"}>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WX4TestMinePage /></Suspense></div>
  </div>

  // const wx4testhistory = <div className="App"><WX4TestHistoryPage /></div>
  const wx4testhistory = <div className='AppWXCISCPCCaintainer'>
    <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPC"}><Suspense fallback={<PageLoading />}><WX4TestHistoryPage /></Suspense></div>
  </div>

  // const wx4testReport = <div className="App"><WX4TestReportPage /></div>
  // const wx4testReport = <div className='AppWXCISXReportCaintainer'>
  //   <div className={isWXCISCMobile ? "AppWXCISX" : "AppWXCISCPCReport"}><WX4TestReportPage /></div>
  // </div>
  let wx4testReport = <div className="App"><Suspense fallback={<PageLoading />}><WX4TestReportPage /></Suspense></div>;
  if (isWXCISCMobile) {
    wx4testReport = <div className="App"><Suspense fallback={<PageLoading />}><WX4TestReportPage /></Suspense></div>
  } else {
    wx4testReport = <div className="AppWXCISXReportCaintainer">
      <div className="AppWXCISCPCReport"><Suspense fallback={<PageLoading />}><WX4TestReportPage /></Suspense></div>
    </div>
  }


  const router = createBrowserRouter([
    {
      path: "/",
      element: mainpage,
    },
    {
      path: "/wxcontactus",
      element: wxcontact,
    },
    {
      path: "/ciscqatest",
      element: cisctestQA,
    },
    {
      path: "/ciscqatestreport",
      element: cisctestReport,
    },
    {
      path: "/assessment",
      element: cisctestmine,
    },
    {
      path: "/ciscqatesthistory",
      element: cisctesthistory,
    },
    {
      path: "/fourtestqa",
      element: wx4testQA,
    },
    {
      path: "/assessmentfourtest",
      element: wx4testmine,
    },
    {
      path: "/fourtestreport",
      element: wx4testReport,
    },
    {
      path: "/fourtesthistory",
      element: wx4testhistory,
    },
  ]);


  return (
    <RouterProvider router={router} />
  );
})

export default App;
